<template>
    <div class="staffDetails">
        <el-form ref="form" :model="form">
            <el-row>
                <el-col :span="2"><div class="seize"></div></el-col>
                <el-col :span="20" class="topTips">
                    <label>员工工号</label>{{form.staffId}}
                </el-col>
            </el-row>
            <el-row class="detail">
                <el-col :span="2"><div class="seize"></div></el-col>
                <el-col :span='22'>
                  <el-col :span="11">
                      <label><span>员工姓名</span></label><span class="point">{{form.staffName}}</span>
                  </el-col>
                  <el-col :span="11">
                      <label><span>联系方式</span></label>{{form.staffPhone}}
                  </el-col>
                  <el-col :span="11">
                      <label><span>身份证号</span></label>{{form.cardId}}
                  </el-col>
                  <el-col :span="11">
                      <label><span>入职日期</span></label>{{form.hiredate | formatDateYear}}
                  </el-col>
                  <el-col :span="11">
                      <label><span>年龄</span></label>{{form.staffAge}} 岁
                  </el-col>
                  <el-col :span="11">
                      <label><span>性别</span></label>{{form.staffSex == 0 ?'女士':'先生'}}
                  </el-col>
                  <el-col :span="11">
                      <label><span>岗位</span></label>{{form.postId | filterPostId(infolist.postIdData)}}
                  </el-col>
                  <el-col :span="11" v-if="form.postId == 0">
                      <label><span>调理师等级</span></label>{{form.staffLevel | filterLevel}}
                  </el-col>
                  <el-col :span="11">
                      <label><span>状态</span></label>{{form.status | filterStatus}}
                  </el-col>
                  <el-col :span="11">
                      <label><span>认证码</span></label>{{form.authenticationCode}}
                  </el-col>
                  <el-col :span="11">
                      <label><span>学历</span></label>{{form.education | filterPostId(infolist.educationList)}}
                  </el-col>
                </el-col>
            </el-row>
            <el-row class="detail borTop">
              <el-col :span="2"><div class="seize"></div></el-col>
              <el-col :span='22'>
                <el-col :span="11">
                    <label><span>紧急联系人</span></label>{{form.emergencyContact}}
                </el-col>
                <el-col :span="11">
                    <label><span>紧急联系方式</span></label>{{form.emergencyContactTelephone}}
                </el-col>
                <el-col :span="11">
                    <label><span>关系</span></label>{{form.relationshipId | filterPostId(infolist.staffrelationShipList)}}
                </el-col>
                <el-col :span="11">
                    <label><span>结婚纪念日</span></label>{{form.weddingDay | formatDateMon}}
                </el-col>
                <el-col :span="11">
                  <el-col :span="9">
                    <label><span>工作经验</span></label>{{form.isExperience == 1?'是 ':'否'}} 
                  </el-col>
                  <el-col :span="15" v-if="form.isExperience == 1">
                    <div style="margin-bottom:5px" v-for="(i,index) in form.experienceList" :key="index">
                      <p>{{i.startTime+' 至 '+i.endTime}}</p>
                      <b>{{i.company}}&nbsp;&nbsp;&nbsp;&nbsp;{{i.post}}</b>
                      <p>{{i.duty}}</p>
                    </div>
                  </el-col>
                </el-col>
                <el-col :span="11">
                    <label><span>梅氏培训经历</span></label>{{form.isTrain == 1?'是 '+(form.certificateNumber):'否'}}
                </el-col>
                <el-col :span="11">
                    <label><span>员工备注</span></label>{{form.remarks}}
                </el-col>
                <el-col :span="24">
                    <label><span>健康证</span></label>
                    <el-upload
                      class="upload-view"
                      :auto-upload="false"
                      action
                      list-type="picture-card"
                      :file-list="fileListData"
                      :on-preview="handlePictureCardPreview"
                      :disabled="true"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img width="100%" :src="dialogImageUrl" alt>
                    </el-dialog>
                </el-col>
              </el-col>
            </el-row>
            <el-row>
                <el-col :span="2"><div class="seize"></div></el-col>
                <el-col :span="22" class="staffTips">注：员工新增后，系统自动创建账号，登录账号为员工工号，初始密码为随机生成并短信发送到手机。</el-col>
            </el-row>
            <el-row>
              <el-col :span="20">
                <el-form-item class="btnOptions">
                    <el-button class="darkBtn" @click="closeTab">关闭</el-button>
                </el-form-item>
              </el-col>
              <el-col :span="4"><div class="seize"></div></el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
import { staffInfo } from "@/api";
import infolist from '@/assets/js/info'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  data() {
    return {
      form: {},
      infolist:infolist,
      dialogVisible: false,
      dialogImageUrl: "",
      fileListData: [],
    };
  },
  computed: {
    options() {
      return this.$store.state.options;
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex;
      },
      set(val) {
        this.$store.commit("set_active_index", val);
      }
    }
  },
  watch: {
    '$route.params.id' (val){
      if(val){
        this.detailInfo();
      }
    }
  },
  created() {
    this.detailInfo();
  },
  methods: {
    detailInfo() {
      staffInfo({
        staffId: this.$route.params.id
      }).then(res => {
        if (res.code == 1) {
          this.form = res.data;
          let fileImgs = [];
          if(this.form.healthCertificateUrl){
            fileImgs.push({
              url: this.form.healthCertificateUrl,
              name: this.form.healthCertificateUrl.split('/')[this.form.healthCertificateUrl.split('/').length-1]
            });
          }
          this.fileListData = fileImgs;
        }
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    closeTab() {
      this.$store.commit("delete_tabs", this.$route.path);
      this.$store.commit("setAliveStatus", true);//保留列表页状态
      this.$router.push('/basicDataCenter/employeeBasicInfo');
    }
  }
};
</script>
<style lang="less" scoped>
.staffDetails {
  width: 100%;
  overflow: hidden;
  padding: 50px 50px 70px;
  position: relative;
  .detail{
    margin-bottom: 0;
    .el-col-11{
      margin-bottom: 28px;
    }
  }
  .upload-view {
    display: inline-block;
  }
  .borTop {
    border-top: 1px dashed #c0c5cf;
    padding-top: 25px;
  }
  .topTips {
    font-size: 15px;
    font-weight: bold;
    color: #222;
    label {
      padding: 0 15px;
    }
  }
  .staffTips {
    font-size: 13px;
    color: #666;
    margin: 40px 0;
    padding-left: 40px;
  }
  .point {
    color: #f83b56;
    font-size: 17px;
    font-weight: bold;
  }
  .seize {
    height: 20px;
  }
}
</style>
<style lang="less">
.staffDetails {
  /* 图片列表禁止上传 */
  .upload-view .el-upload.el-upload--picture-card {
    display: none;
  }
  .upload-view
    .el-upload-list__item.is-success
    .el-upload-list__item-status-label,
  .upload-view .el-icon-upload-success.el-icon-check {
    opacity: 0;
    display: none;
  }
  .upload-view .el-upload-list--picture-card .el-upload-list__item {
    border: none;
  }
  .el-row {
    margin-bottom: 28px;
  }
  label {
    width: 140px;
    text-align: right;
    display: inline-block;
    margin-right: 10px;
    span {
      min-width: 95px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      display: inline-block;
      padding: 0 15px;
      background: #eff1f5;
      border-radius: 15px;
      color: #444;
    }
  }
  .btnOptions {
    text-align: center;
    margin-top: 22px;
    .el-button {
      width: 135px;
      height: 46px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/staffDetails.vue